import { type IResponse, encryptedRequest } from "../core/api.client";
export const LIVE_COMMERCE_API_PATHS = {
  SET_REMINDER: `/api/v1/live-commerce/reminder`,
  REMOVE_REMINDER: `/api/v1/live-commerce/remove-reminder`,
  GET_USER_REMINDERS: `/api/v1/live-commerce/reminders/user`,
} as const;

export interface SetReminderRequest {
  mobileNo: string;
  influencerId: string;
  videoId: string;
}

export interface LiveCommerceReminder {
  id: string;
  influencerId: string;
  videoId: string;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface SetReminderResponse {
  reminder: LiveCommerceReminder;
  isNew: boolean;
}

export interface RemoveReminderRequest {
  mobileNo: string;
  videoId: string;
  influencerId: string;
}

export interface RemoveReminderResponse {
  deleted: boolean;
}

export interface GetUserRemindersRequest {
  mobileNo: string;
  influencerId?: string;
}

export interface GetUserRemindersResponse {
  count: number;
  reminders: LiveCommerceReminder[];
}

export const setReminder = async (
  payload: SetReminderRequest
): Promise<IResponse<SetReminderResponse>> => {
  try {
    const response = await encryptedRequest<SetReminderResponse, SetReminderRequest>({
      method: "POST",
      url: LIVE_COMMERCE_API_PATHS.SET_REMINDER,
      data: payload,
    });

    if (response.statusCode !== 90 || response.status !== "success") {
      throw new Error(response.message || "Failed to set reminder");
    }

    return response;
  } catch (error) {
    if (error instanceof Error) throw error;
    throw new Error("An unexpected error occurred while setting reminder");
  }
};

export const removeReminder = async (
  payload: RemoveReminderRequest
): Promise<IResponse<RemoveReminderResponse>> => {
  try {
    const response = await encryptedRequest<RemoveReminderResponse, RemoveReminderRequest>({
      method: "POST",
      url: LIVE_COMMERCE_API_PATHS.REMOVE_REMINDER,
      data: payload,
    });

    if (response.statusCode !== 90 || response.status !== "success") {
      throw new Error(response.message || "Failed to remove reminder");
    }

    return response;
  } catch (error) {
    if (error instanceof Error) throw error;
    throw new Error("An unexpected error occurred while removing reminder");
  }
};

export const getUserReminders = async (
  payload: GetUserRemindersRequest
): Promise<IResponse<GetUserRemindersResponse>> => {
  try {
    const response = await encryptedRequest<GetUserRemindersResponse, GetUserRemindersRequest>({
      method: "POST",
      url: LIVE_COMMERCE_API_PATHS.GET_USER_REMINDERS,
      data: payload,
    });

    if (response.statusCode !== 90 || response.status !== "success") {
      throw new Error(response.message || "Failed to get user reminders");
    }

    return response;
  } catch (error) {
    if (error instanceof Error) throw error;
    throw new Error("An unexpected error occurred while getting user reminders");
  }
};

export const liveCommerceService = {
  setReminder,
  removeReminder,
  getUserReminders,
};
